__turbopack_context__.v({
  "card": "index-module-scss-module__s88Lza__card",
  "cardDescription": "index-module-scss-module__s88Lza__cardDescription",
  "cardTitle": "index-module-scss-module__s88Lza__cardTitle",
  "container": "index-module-scss-module__s88Lza__container",
  "description": "index-module-scss-module__s88Lza__description",
  "eyebrow": "index-module-scss-module__s88Lza__eyebrow",
  "gridWrap": "index-module-scss-module__s88Lza__gridWrap",
  "section": "index-module-scss-module__s88Lza__section",
  "successIcon": "index-module-scss-module__s88Lza__successIcon",
  "title": "index-module-scss-module__s88Lza__title",
});
